import React from 'react'
import { Link } from 'gatsby'

const Pagination = ({ pages, current_page }) => {
  // Array der Seiten für Paginate-View
  const paginationArray = Array.from({ length: pages }, (v, i) => i + 1)

  const prev_page = current_page > 1 ? current_page - 1 : false
  const next_page = current_page < pages ? current_page + 1 : false

  const paginateLinkClass = function (page, current_page) {
    if (!page) {
      return 'page-item disabled'
    } else if (page == current_page) {
      return 'page-item active'
    } else {
      return 'page-item'
    }
  }

  return (
    <section className="pagination-block">
      <div className="pagination-block-container">
        <ul className="pagination">
          <li className={paginateLinkClass(prev_page, current_page)}>
            <Link to={`?page=${prev_page}`} className="page-link">
              <i className="far fa-angle-left"></i>
            </Link>
          </li>
          {paginationArray.map((page, index) => (
            <li className={paginateLinkClass(page, current_page)} key={index}>
              <Link to={`?page=${page}`} className="page-link">
                {page}
              </Link>
            </li>
          ))}
          <li className={paginateLinkClass(next_page, current_page)}>
            <Link to={`?page=${next_page}`} className="page-link">
              <i className="far fa-angle-right"></i>
            </Link>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default Pagination
